module.exports = __webpack_public_path__ + "assets/img/copy.d15eddc7.svg";